import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ModifyDatasourceDeprecatedForm from './form'

const ModifyDatasourceDeprecatedDialog = React.forwardRef(function ModifyDatasourceDeprecatedDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Deprecated Status'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ModifyDatasourceDeprecatedForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ModifyDatasourceDeprecatedDialog.propTypes = {
  onComplete: PropTypes.func
}

ModifyDatasourceDeprecatedDialog.defaultProps = {
  onComplete: () => {}
}

export default ModifyDatasourceDeprecatedDialog
